import { InMemoryProvider } from "@openfeature/web-sdk";

import { flagConfig } from "../flags";

/**
 * OpenFeature InMemoryProvider (Web SDK 用)
 *
 * React などのブラウザ環境で使用
 */
export const webFlagProvider = new InMemoryProvider(flagConfig);
